/* eslint-disable */
const textInput =`<problem>
  <stringresponse type="ci">
    <additional_answer />
    <textline size="20"/>
  </stringresponse>
</problem>`

export default textInput;